import { render, staticRenderFns } from "./ProgressArrow.vue?vue&type=template&id=5a0623b7&"
import script from "./ProgressArrow.vue?vue&type=script&lang=ts&"
export * from "./ProgressArrow.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressArrow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports